import React, { useState, useEffect } from "react";
import { API } from "../../lib/api";

/**
 * Ricava le iniziali di un'azienda: max 2 caratteri, uppercase.
 *  - "Acme S.p.A."   → "AS"
 *  - "Enel"          → "EN"
 *  - "Foo & Bar srl" → "FB"
 */
function initials(name) {
    if (!name || typeof name !== "string") return "?";
    const cleaned = name.replace(/\bs\.?\s*p\.?\s*a\.?\b|\bs\.?\s*r\.?\s*l\.?\b|\bs\.?\s*n\.?\s*c\.?\b|\bs\.?\s*a\.?\s*s\.?\b/gi, "").trim();
    const source = cleaned || name;
    const tokens = source.split(/[\s.&/_-]+/).filter(Boolean);
    if (tokens.length === 0) return name.slice(0, 1).toUpperCase();
    if (tokens.length === 1) return tokens[0].slice(0, 2).toUpperCase();
    return (tokens[0][0] + tokens[1][0]).toUpperCase();
}

/**
 * Logo cliente con fallback iniziali.
 *  - Usa `has_logo` come contract stabile dal backend.
 *  - Se `endpoint` è passato, viene usato come src assoluto (portale cliente).
 *    Altrimenti si costruisce `${API}/internal/clients/{client.id}/logo`
 *    (dashboard interno).
 *  - `<img>` in modalità stessa-origin (cookie httpOnly incluso automaticamente).
 *  - `onError` → mostra placeholder senza rompere il layout (es. file R2 cancellato).
 */
export default function ClientLogo({ client, size = 40, className = "", endpoint = null }) {
    const [failed, setFailed] = useState(false);
    // reset stato se cambia cliente o endpoint
    useEffect(() => { setFailed(false); }, [client?.id, client?.has_logo, endpoint]);

    const canFetch = !!(client && client.has_logo && !failed && (endpoint || client.id));
    const style = {
        width: `${size}px`,
        height: `${size}px`,
        fontSize: `${Math.max(11, Math.round(size * 0.34))}px`,
    };

    if (canFetch) {
        const src = endpoint || `${API}/internal/clients/${client.id}/logo`;
        return (
            <div className={`lt-logo-square ${className}`} style={style} data-testid="client-logo-img-wrap">
                <img
                    src={src}
                    alt={`Logo ${client.company_name || ""}`}
                    onError={() => setFailed(true)}
                    style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
                    data-testid="client-logo-img"
                />
            </div>
        );
    }
    return (
        <div className={`lt-logo-square ${className}`} style={style} data-testid="client-logo-initials" aria-label={`Logo ${client?.company_name || ""}`}>
            {initials(client?.company_name)}
        </div>
    );
}
